import { useQuery } from 'react-query'
import { QueryKeys } from 'constants/queries'
import { getArtists } from 'api/artists'
import { QueryParams } from 'models/common/api'
import { GetArtistsResponse } from 'models/artists/ApiModels'
import { Artists } from 'models/artists/EntityModels'
import { deserializeArtists } from 'serializers/artists'

const useGetArtists = (params: QueryParams) =>
  useQuery([QueryKeys.ARTISTS, params], getArtists, {
    select: (data: GetArtistsResponse): Artists => deserializeArtists(data)
  })

export default useGetArtists
